import { z } from 'zod';

export const commissionItemSchema = z.object({
    commissionItem_id: z.number(),
    commission_id: z.number(),
    commissionDischarge_id: z.number().nullable(),
    commissionLoading_id: z.number().nullable(),

    name: z.string().nullable(),
    packaging: z.string().nullable(),
    quantity: z.number({ coerce: true }).nullable(),
    width: z.number({ coerce: true }).nullable(),
    length: z.number({ coerce: true }).nullable(),
    height: z.number({ coerce: true }).nullable(),
    weight: z.number({ coerce: true }).nullable(),
    weightBrutto: z.number({ coerce: true }).nullable(),
    loadingMeters: z.number({ coerce: true }).nullable(),
    note: z.string().nullable(),
    size: z.string().nullable(),

    deleted: z.boolean(),
});
export type TCommissionItem = z.infer<typeof commissionItemSchema>;
